/**
 * Created by akrio on 2018/4/27.
 */
/**
 * setting中日期
 * @type {*[]}
 */
export const weekType = [
  { key: 0, text: "Every Sunday", abbreviation: "Sun", singleText: "Sunday" },
  { key: 1, text: "Every Monday", abbreviation: "Mon", singleText: "Monday" },
  { key: 2, text: "Every Tuesday", abbreviation: "Thu", singleText: "Tuesday" },
  {
    key: 3,
    text: "Every Wednesday",
    abbreviation: "Wed",
    singleText: "Wednesday",
  },
  {
    key: 4,
    text: "Every Thursday",
    abbreviation: "Thu",
    singleText: "Thursday",
  },
  { key: 5, text: "Every Friday", abbreviation: "Fri", singleText: "Friday" },
  {
    key: 6,
    text: "Every Saturday",
    abbreviation: "Sat",
    singleText: "Saturday",
  },
];
